import React,{ useState, useEffect, useRef } from 'react';
import { Container,Row,Col,Table,Spinner,Nav,Form,Button } from 'react-bootstrap';
import { useSelector,useDispatch } from 'react-redux'; 
import { setStateHome, setStateGlobal, showAlert } from '../../reducers/appReducer';
import TablaRecibos from '../TablaRecibos/TablaRecibos';
import { number_format } from '../../utils/utils';
import moment from "moment";
moment.locale("mx");

function Vendedores({typeView,socket}){

  const stateGlobal = useSelector( (state) => state.agents );
  const stateHome = stateGlobal.home;
  const dispatch = useDispatch();

  const {
    fechaInicio,
    fechaFin,
  } = stateHome;

  const refDateToday = useRef(null);
  const refDateTomorrow = useRef(null);
  const today = moment().add(-1, 'year').format('YYYY-MM-DD');
  const tomorrow = moment(today,'YYYY-MM-DD').add(1, 'year').format('YYYY-MM-DD');
  
  const [data,setData] = useState({
    section: 1,
    vendedores: [],
    tramites: [],
    isLoadPanel: true,
    isLoadPanel2: true,
  })
  const [windowDimenion, detectHW] = useState({
    winWidth: window.innerWidth,
    winHeight: window.innerHeight,
  })

  const { section, vendedores, isLoadPanel, isLoadPanel2, tramites} = data;

  const handleSetSection = (section) => {
    setData( prevState => ({
      ...prevState,
      section
    }))
  }

  const handleSubmitSearch = (e) => {
    e.preventDefault();
    getTramitesByDate();
  }

  const getTramitesByDate = () =>{
    dispatch(setStateHome( { isLoadPanel: true}));
    const data = {
      date_start: refDateToday.current.value,
      date_end: refDateTomorrow.current.value 
    };
    fetch('https://mercedes.wsoft.com.mx/interbrokers/REST/Controller.php?opt=getTramitesByDate',{
      method: 'POST',
      mode:'cors',
      body: JSON.stringify(data),
    })
    .then( response => response.json())
    .then( response => {
      dispatch( setStateGlobal({ dataArray: response.documents, }) )
      dispatch( setStateHome( { isLoadPanel: false}) );
      
    })
  }

  const detectSize = () => {
    detectHW({
      winWidth: window.innerWidth,
      winHeight: window.innerHeight,
    })
  }
  
  useEffect(() => {
    window.addEventListener('resize', detectSize)
    console.log(windowDimenion)
    return () => window.removeEventListener('resize', detectSize)
  }, [windowDimenion])

  useEffect(() => {

    dispatch(setStateHome( { 
      fechaInicio: today,
      fechaFin: tomorrow,
      customDate: true
    }));
    
    fetch('https://mercedes.wsoft.com.mx/interbrokers/REST/Controller.php?opt=getDirectorioNuevo',{
      method: 'POST',
      mode: 'cors',
    })
    .then( response => response.json() )
    .then( response => {
      setData( prevState => ({
        ...prevState,
        vendedores: response.vendedores.documents,
        isLoadPanel: false
      }))
    })

    const data = {
      date_end : tomorrow,
      data_start: today,
    }

    fetch('https://mercedes.wsoft.com.mx/interbrokers/REST/Controller.php?opt=getTramitesByDate',{
      method: 'POST',
      mode: 'cors',
      body: JSON.stringify(data),
    })
    .then( response => response.json() )
    .then( response => {
      console.log(response)
      setData( prevState => ({
        ...prevState,
        tramites: response.documents,
        isLoadPanel2: false
      }))
    })

  },[])

  const verificarTramitesPagados = (tramite) => {
    const { arrCobranza, cantidad } = tramite;
    let totalAbonos = 0
    arrCobranza.map((t,e) => {
      totalAbonos += parseFloat(t.cantidadRecibida)
    })
    console.log('totalAbonos: ' + totalAbonos);
    return ( (cantidad - totalAbonos) === 0) ? true : false;
  }

  // let dataPagoComisiones = [];
  // tramites.map((t,e) => {
  //   if(t.arrCobranza.length > 0) {
  //     if(verificarTramitesPagados(t)){
  //       dataPagoComisiones.push(t)
  //     }
  //   }
  // })

  // console.log('Pago Comisiones', dataPagoComisiones)

  return(
    <Container fluid>
      <div className="ws-main-container container-fluid">
        <div className="ws-tab-container pb-3">
          <ul className="nav nav-pills">
            <li className="nav-item">
              <a className={`nav-link ${ (section === 1) && 'active' }`} aria-current="page" href="#" onClick={ () => handleSetSection(1) }>Porcentaje a asignar</a>
            </li>
            <li className="nav-item">
              <a className={`nav-link ms-2 ${ (section === 2) && 'active' }`} href="#" onClick={ () => handleSetSection(2) }>Pago de comisiones</a>
            </li>
          </ul>

          {
            section === 2 && (
              <Row className="mt-3">
                <Col>
                  {/* Formulario de búsqueda por rango de fecha */}
                  <Form onSubmit={handleSubmitSearch} className="d-flex align-items-end flex-md-row gap-2 ws-main-datebar">
                    <Form.Group className="" style={{float:'right'}}>
                      <Form.Control ref={refDateToday} type="date" defaultValue={fechaInicio} />
                    </Form.Group>
                    <Form.Group className="" style={{float:'right'}}>
                      <Form.Control ref={refDateTomorrow} type="date" defaultValue={fechaFin} />
                    </Form.Group>
                    <Form.Group className="" style={{float:'right'}}>
                      <Button type="submit" className="ws-btn-blue-2">&nbsp;&nbsp;<i className="bi bi-search pe-2"></i>{ windowDimenion.winWidth > windowDimenion.winHeight &&( "Buscar") }</Button>
                    </Form.Group>
                  </Form>
                </Col>
              </Row>
            )
          }

        </div>
        {
          section === 1 && (
           <div className="ws-box-container">
              { isLoadPanel && (
              <div className="ws-loader-container">
                <Spinner animation="border" variant="danger" size="lg"/>
              </div>) }
              <Table hover>
                <thead>
                  <tr>
                    <th width="60%">Nombre del vendedor</th>
                    <th width="30%">%</th>
                    <th width="10%">Opciones</th>
                  </tr>
                </thead>
                <tbody>
                  {
                    vendedores && vendedores.length > 0 && (
                      vendedores.map((t,e) => (
                        <tr key={`vendedor-${e}`}>
                          <td>{t.nombre_completo}</td>
                          <td>10%</td>
                          <td>
                            <ul className="navbar-nav ms-auto ws-dropdown-list">
                              <li className="nav-item dropdown position-static">
                                <a className="nav-link dropdown-toggle" href="#" id="navbarDropdown" role="button" data-bs-toggle="dropdown" aria-expanded="false" boundary="viewport">
                                  <i className="bi bi-three-dots-vertical"></i>
                                </a>
                                <div className="dropdown-menu dropdown-menu-end animate slideIn" aria-labelledby="navbarDropdown">
                                  <a onClick={ () => console.log('opcion1') } className="dropdown-item" href="#"><i className="bi bi-pencil pe-2" ></i> Editar</a>
                                </div>
                              </li>
                            </ul>
                          </td>
                        </tr>
                      ))
                    )
                  }
                </tbody>
              </Table>
           </div>
          )
        }

        {
          section === 2 && (
            <>
              { isLoadPanel2 && (
              <div className="ws-loader-container">
                <Spinner animation="border" variant="danger" size="lg"/>
              </div>) }
              <TablaRecibos
                filteredData={tramites} 
                typeView={typeView}
              />
           </>
          )
        }
      </div>
    </Container>
  )
}

export default Vendedores;